import { MutableRefObject, createContext } from 'react';
import { IRecipientProfileHeaderInfo } from '@nkr/models/index';
import { RecipientAction } from '@nkr/enums/index';
import { ToggleType } from './toggle-type';
import { AfterAction } from './after-action';

export interface IRecipientProfileContext {
    activeKey: string,
    isAdmin: boolean,
    centerId: number,
    recipientId: number,
    headerInfo: IRecipientProfileHeaderInfo,
    toggleType: ToggleType,
    messages: string[],
    showCheekOrderNotification: boolean,
    hasChanges: boolean,
    allowSaveWithNoChanges: boolean,
    dataChangedWarning: {
        show: boolean,
        title: string,
        href: string
    },
    updateAfterLoad: (headerInfo: IRecipientProfileHeaderInfo) => void,
    updateErrors: (toggleType: ToggleType, messages: string[]) => void,
    updateHasChanges: (value: boolean) => void,
    updateAllowSaveWithNoChanges: (value: boolean) => void,
    updateDataChangedWarning: (show: boolean, title: string, href: string) => void,
    refreshHeader: () => void,
    onCheekSwabRequest: (action: RecipientAction) => void,
    onCheekOrderNotify: (show: boolean) => void,
    registerSave: (saveRef: MutableRefObject<any>, save: Function) => void,
    onItemSelected: (id: number, action: RecipientAction) => void,
    doAfterAction?: (AfterAction: AfterAction) => void
}

export const RecipientProfileContext = createContext<IRecipientProfileContext | null>(null);
export const RecipientProfileProvider = RecipientProfileContext.Provider;

export const RecipientProfileConsumer = ({ children }) => {
    return (
        <RecipientProfileContext.Consumer>
            {(context) => {
                if (context === undefined) {
                    throw new Error('RecipientProfileContext must be used within a RecipientProfileProvider')
                }
                return children(context)
            }}
        </RecipientProfileContext.Consumer>
    );
}